<template>
  <div class="global">
    <el-row>
      <el-col class="title" :span="12">
        <p>Global Footprint</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="content" :span="21">
        <p>
          Kiwigame is made up of individuals from over 20 countries, and we have grown to have millions of players in over 100 countries.
        </p>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="strong-content" :span="17">
        <p>Join our team and be a part of our continued global gaming market expansion!</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="map" :span="18"><img :src="imageRoot + '/home/worldmap.png'" alt=""></el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <swiper-view :imageList="images"></swiper-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SwiperView from '@/components/SwiperComponent/MultSwiper.vue'

export default {
  data: function () {
    return {
      imageRoot: process.env.VUE_APP_IMAGE_PATH
    }
  },
  computed: {
    images: function () {
      return [
        [
          `${this.imageRoot}/home/global/guangzhou.png`,
          `${this.imageRoot}/home/global/Tokyo.png`,
          `${this.imageRoot}/home/global/newyork.png`,
          `${this.imageRoot}/home/global/moscow.png`
        ],
        [
          `${this.imageRoot}/home/global/london.png`,
          `${this.imageRoot}/home/global/MexicoCity.png`,
          `${this.imageRoot}/home/global/KualaLumpur.png`,
          `${this.imageRoot}/home/global/hongkong.png`
        ],
        [
          `${this.imageRoot}/home/global/RiodeJaneiro.png`,
          `${this.imageRoot}/home/global/sdyney.png`,
          `${this.imageRoot}/home/global/taipei.png`,
          `${this.imageRoot}/home/global/Bangkok.png`
        ]
      ]
    }
  },
  components: {
    SwiperView
  }

}
</script>
<style lang="scss" scoped>
.global{
  .title{
    @include normalTitle('#{$imageRoot}/home/title_dot.png',45px, 45px, -34px, 75px, -1, 76.8px);
  }
  .content{
    p{
      margin-top: 25.6px;
      font-family: ubuntu;
      font-size: 18px;
      color: #636363;
      line-height: 36px;
      margin-left: -28px;
    }
  }
  .strong-content{
    p{
      margin-top: 16px;
      font-family: ubuntuB;
      font-size: 18px;
      color: #636363;
      margin-left: -28px;
      white-space: nowrap;
      margin-bottom: 30px;
    }

  }
  .map{
    margin-top:32px;
    margin-left: -28px;
    img{
      width: 840px;
    }
  }
}
</style>
